export default "__VITE_ASSET__DAIt57GG__"